import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const priceSurveyStatusOptions = [
  { label: 'Pendente', value: 'pending' },
  { label: 'Aprovada', value: 'approved' },
  { label: 'Rejeitada', value: 'rejected' },
  { label: 'Desativada', value: 'disabled' },
]

export const priceSurveyStatusStrategy = optionsToStrategy(priceSurveyStatusOptions)
